var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-layout",
    { attrs: { row: "", wrap: "" } },
    [
      _c(
        "v-flex",
        {
          staticClass: "card-border-right",
          attrs: { xl4: "", lg5: "", md12: "", sm12: "" },
        },
        [
          _c(
            "v-layout",
            {
              attrs: {
                row: "",
                column: "",
                reverse: _vm.$vuetify.breakpoint.smAndDown,
              },
            },
            [
              _c("ContinuousStationComponents", {
                ref: "stationComponents",
                attrs: {
                  disabled: _vm.disabledStates.stations || !_vm.isInitialized,
                  selection: _vm.selection,
                  timeSeriesStations: _vm.allTimeSeriesStations,
                },
                on: {
                  stations: function ($event) {
                    _vm.selection.stations = $event
                  },
                  loading: function ($event) {
                    _vm.loadingStates.stations = $event
                  },
                },
              }),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c("ContinuousDateRange", {
                ref: "dateRange",
                attrs: {
                  disabled: _vm.disabledStates.dateRange,
                  availableDateRange: _vm.availableDateRange,
                },
                on: {
                  dateRange: function ($event) {
                    _vm.selection.dateRange = $event
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        {
          staticClass: "card-bg-2 card-border-left",
          attrs: { xl8: "", lg7: "", md12: "", sm12: "" },
        },
        [
          _c("TimeSeries", {
            ref: "timeSeries",
            attrs: {
              disabled: _vm.disabledStates.timeSeries,
              allTimeSeries: _vm.allTimeSeries,
              selectedStationIds: _vm.selectedStationIds,
            },
            on: { changed: _vm.onTimeSeriesSelect },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }